import React, { useCallback } from 'react';
import { SWORN_DATA } from 'src/gameData';
import { NimueSelection, NimueModifierTexts } from '../../types';
import NimueOption from './items/NimueOption';

interface NimuePanelProps {
  options: NimueSelection;
  currentModifiers: NimueModifierTexts;
  toggleOption: (option: 'option1' | 'option2') => void;
  selectedWeapon: string | null;
}

const NIMUE_ASSETS = SWORN_DATA.ui_assets?.nimue || {
  mod_frame_on: "",
  mod_frame_off: "",
  text_bg: "",
  weapon_base_path: ""
};

const NimuePanel: React.FC<NimuePanelProps> = ({
  options,
  currentModifiers,
  toggleOption,
  selectedWeapon
}) => {
  const weaponImage = selectedWeapon ? `${NIMUE_ASSETS.weapon_base_path}${selectedWeapon}.png` : '';

  return (
    <div id="nimue-panel-container">
      {/* Option 1 (Left) */}
      <NimueOption 
        optionKey="option1" 
        options={options} 
        currentModifiers={currentModifiers} 
        toggleOption={toggleOption} 
        assets={NIMUE_ASSETS} 
      />

      {/* Weapon Image (Center) */}
      <div className="nimue-weapon-display">
         {weaponImage && <img src={weaponImage} alt={selectedWeapon || 'Weapon'} />}
      </div>

      {/* Option 2 (Right) */}
      <NimueOption 
        optionKey="option2" 
        options={options} 
        currentModifiers={currentModifiers} 
        toggleOption={toggleOption} 
        assets={NIMUE_ASSETS} 
      />
    </div>
  );
};

export default NimuePanel;
